export default {"src":"/_next/static/media/EmptyStreet.206474d3.svg","height":451,"width":998,"blurWidth":0,"blurHeight":0};